import React, { useState, useEffect } from 'react';
import { 
  Snackbar, 
  Alert, 
  LinearProgress, 
  Box, 
  Typography,
  IconButton 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const UpdateNotifier = () => {
  const [updateStatus, setUpdateStatus] = useState('');
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check if we're in Electron environment
    if (window.electronAPI) {
      // Listen for update status
      window.electronAPI.onUpdateStatus((message) => {
        setUpdateStatus(message);
        if (message && !message.includes('up to date')) {
          setOpen(true);
        }
      });

      // Listen for download progress
      window.electronAPI.onDownloadProgress((percent) => {
        setDownloadProgress(percent);
      });

      // Cleanup listeners on unmount
      return () => {
        window.electronAPI.removeUpdateStatusListener();
        window.electronAPI.removeDownloadProgressListener();
      };
    }
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const isDownloading = updateStatus.includes('Download') && downloadProgress > 0;

  return (
    <>
      {/* Update notification */}
      <Snackbar
        open={open}
        autoHideDuration={isDownloading ? null : 6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={
            updateStatus.includes('Error') ? 'error' :
            updateStatus.includes('available') ? 'info' :
            updateStatus.includes('downloaded') ? 'success' :
            'info'
          }
          action={
            !isDownloading && (
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )
          }
          sx={{ width: '100%' }}
        >
          <Typography variant="body2">{updateStatus}</Typography>
          {isDownloading && (
            <Box sx={{ width: '100%', mt: 1 }}>
              <LinearProgress 
                variant="determinate" 
                value={downloadProgress} 
                sx={{ height: 6, borderRadius: 1 }}
              />
              <Typography variant="caption" sx={{ mt: 0.5 }}>
                {downloadProgress.toFixed(1)}% complete
              </Typography>
            </Box>
          )}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UpdateNotifier;